import { plainText, richText } from '../../../../../../../modules/validators';
import { trimSpacesLeft } from '../../../../../../../modules/formatters';
import { FormVmItemConfigType, InitialData } from '../../../../../../../infrastructure/form-viewmodel-controller';
import { ConnectionType, LayoutOption } from '../../../../../../../api/connections.dao';
import { buildConfigList } from '../../../../../../../infrastructure/utils/form-config.utils';

export enum FieldKey {
    TYPE = 'type',
    LABEL = 'label',
    NEVERLATE = 'enableNeverlate',
    LAYOUT = 'layout',
    STANDBY_MESSAGE = 'standByMessage',
    PUBLISHED = 'publishedEnabled',
    PASSPORT_REPLAY = 'passportReplayEnabled',
    ENABLE_QANDA = 'enableQAndA',
    ENABLE_OVERVIEW = 'enableOverview',
    ENABLE_SPEAKERS = 'enableSpeakers',
    ENABLE_EXPIRATION_DATE = 'enableExpirationDate',
    EXPIRATION_DAYS = 'expirationDays',
}

const expirationDateValidator = (val: number, formValues: InitialData) => {
    const checkCondition = val >= 1 && val <= 999 && !Number.isNaN(val);
    const valid = !formValues[FieldKey.ENABLE_EXPIRATION_DATE] || checkCondition;
    const validationMessage = valid
        ? null
        : { id: 'oe.validation.expirationDate.message', defaultMessage: 'Expiration date must be between 1 and 999 days after meeting date.' };

    return { valid: valid, validationMessage: validationMessage };
};

export const FORM_CONFIG = {
    [FieldKey.TYPE]: {
        labelDescriptor: { id: 'oe.templates.connection.type', defaultMessage: 'Connection Type', description: 'Label text' },
        defaultValue: ConnectionType.Knovio,
        readOnly: true
    },
    [FieldKey.LABEL]: {
        labelDescriptor: { id: 'oe.templates.connection.label', defaultMessage: 'Label', description: 'Label text' },
        defaultValue: '',
        validators: [plainText.maxLength.short],
        formatters: [trimSpacesLeft]
    },
    [FieldKey.NEVERLATE]: {
        defaultValue: true
    },
    [FieldKey.LAYOUT]: {
        labelDescriptor: { id: 'oe.templates.connection.layout', defaultMessage: 'Layout', description: 'Label text' },
        defaultValue: LayoutOption.VideoRight
    },
    [FieldKey.STANDBY_MESSAGE]: {
        labelDescriptor: { id: 'oe.templates.connection.standByMessage', defaultMessage: 'Standby Message', description: 'Label text' },
        defaultValue: 'Please stand by for the broadcast to begin…',
        validators: [richText.maxLength.long]
    },
    [FieldKey.PUBLISHED]: {
        defaultValue: true
    },
    [FieldKey.PASSPORT_REPLAY]: {
        defaultValue: false
    },
    [FieldKey.ENABLE_OVERVIEW]: {
        defaultValue: true
    },
    [FieldKey.ENABLE_QANDA]: {
        defaultValue: false
    },
    [FieldKey.ENABLE_SPEAKERS]: {
        defaultValue: false
    },
    [FieldKey.ENABLE_EXPIRATION_DATE]: {
        defaultValue: false
    },
    [FieldKey.EXPIRATION_DAYS]: {
        labelDescriptor: { id: 'oe.templates.connection.expirationDays', defaultMessage: 'Expiration Date', description: 'Label text' },
        validators: [expirationDateValidator],
        defaultValue: 30
    },
};

export const configList: FormVmItemConfigType[] = buildConfigList(FORM_CONFIG);
